import { grey, red } from '@mui/material/colors'
import { dark } from '@mui/material/styles/createPalette'
import React from 'react'
import { MdFiberManualRecord } from 'react-icons/md'


const BedCountCircles = ({ roomdto }) => {
  return (
    Array.from({ length: roomdto?.bedCount }, (item) =>
      <MdFiberManualRecord style={{ fontSize: '1.1rem', color: roomdto.bedCount == 2 ? dark : (roomdto.bedCount == 3 ? red[800] : grey[500]) }} key={Math.random()} />)
  )
}

export default BedCountCircles